import React, { useState } from 'react';
import classNames from 'classnames';
import css from './styles.module.css';
import { Button } from '@mm/components';
import { useClickOutside } from '@mm/hooks';
import TextInput from '../../../../../../../../common/components/TextInput';
import { ModalCloseButton } from '../../../../../../../../common/modals/components/ModalCloseButton/ModalCloseButton';

export type Link = {
  title?: string;
  href?: string;
};

type Props = {
  className?: string;
  link: Link;
  onSubmit: (link: Link) => void;
  onCancel: () => void;
};

export const LinkPrompt = ({ className, link, onSubmit, onCancel }: Props) => {
  const ref = useClickOutside<HTMLDivElement>(onCancel);

  const [href, setHref] = useState(link.href || '');
  const [title, setTitle] = useState(link.title || '');

  const handleUpdate = () => onSubmit({ href, title });

  return (
    <div className={classNames(className, css.container)} ref={ref}>
      <ModalCloseButton onClick={onCancel} />

      <h5 className={css.title}>{link.title ? 'Edit link' : 'Add link'}</h5>
      {!link.title && (
        <div className={css.field}>
          <span>Text to display</span>
          <TextInput
            type="text"
            placeholder="Text to display"
            autoComplete="off"
            value={title}
            onChange={e => setTitle(e.target.value)}
          />
        </div>
      )}
      <div className={css.field}>
        <span>URL</span>
        <TextInput
          type="text"
          placeholder="URL"
          autoComplete="off"
          className=""
          value={href}
          onChange={e => setHref(e.target.value)}
        />
      </div>
      <div className={css.buttons}>
        <Button onClick={handleUpdate}>OK</Button>
        <Button onClick={onCancel} color="link">
          Cancel
        </Button>
      </div>
    </div>
  );
};
